// extracted by mini-css-extract-plugin
export default {"actions":"ClientsTableHead_actions__-M7d5"};